import { ApplyVendorCreditsCtrl }            from './vendor-credits.apply-vendor-credits';
import { VendorCreditApplicationsListCtrl }  from './vendor-credits.vendor-credit-application-list';
import { VendorCreditsCtrl }                 from './vendor-credits.vendor-credits';
import { VendorCreditsStates }               from './vendor-credits.states.ajs';

angular.module('workshop.vendorCredits', [])

.controller('applyVendorCreditsCtrl',           ApplyVendorCreditsCtrl)
.controller('vendorCreditApplicationsListCtrl', VendorCreditApplicationsListCtrl)
.controller('VendorCreditsCtrl',                VendorCreditsCtrl)

.config(VendorCreditsStates);